













































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import JobWorkerStatus from '@/components/JobWorkers/Display/JobWorkerStatus.vue'
import JobWorkerStatusEnum from '@/models/JobWorkers/JobWorkerStatus';
import JobWorker from '@/components/JobWorkers/JobWorker.vue';

@Component({
  name: 'JobPlacedWorkers',
  components: { JobWorkerStatus, JobWorker }
})
export default class extends GiganautVue {

	jobWorkerStatusEnum = JobWorkerStatusEnum;
	page = 1;
	perPage = 8;

	get selectedJobWorker() {
		return JobDetailsModule.jobWorkersVM.selectedPlacedJobWorker;
	}

	set selectedJobWorker(value: JobWorkerDto) {
		JobDetailsModule.jobWorkersVM.selectedPlacedJobWorker = value;
	}
	get currentJob() {
		return JobDetailsModule.currentJob;
	}
	
	get jobWorkers() {
		return JobDetailsModule.jobWorkersVM.jobWorkers;
	}

	get pagedJobWorkers() {
		return this.placedWorkers.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	get placedWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatusEnum.Placed
		))
	}

	async onPageChanged(input: number){
		JobDetailsModule.jobWorkersVM.selectedPlacedJobWorker = (this.pagedJobWorkers[0]);
	}

	get loadingWorkers() {
		return JobDetailsModule.loadingWorkers;
	}
}
